import { EGetLocationsActionType } from './types';

import { prepareLocations } from '../../mappers/prepareLocations';
import { actionGenerator } from '../../redux/actionGenerator';
import { ILocation } from '../../types/geoLocation/locations';
import { TThunkAction } from 'shared/types/redux';
import {
  fetchCianApiMobileSiteV1SearchRegionsCities,
  TCianApiMobileSiteV1SearchRegionsCitiesResponse,
} from 'shared/repositories/monolith-python/cian-api/mobile-site/v1/search-regions-cities';
import { ResponseError } from 'shared/errors/responseError';
import { TPrimitives } from '@cian/peperrors';

const setStatusLoading = actionGenerator<EGetLocationsActionType.Loading>(EGetLocationsActionType.Loading);
const setStatusSucceed = actionGenerator<EGetLocationsActionType.Succeed, ILocation[]>(EGetLocationsActionType.Succeed);
const setStatusFailed = actionGenerator<EGetLocationsActionType.Failed>(EGetLocationsActionType.Failed);

export function getLocations(): TThunkAction<Promise<ILocation[]>> {
  return async (dispatch, getState, { httpApi, logger }) => {
    dispatch(setStatusLoading());

    const { subdomain } = getState();

    try {
      const locationsData: TCianApiMobileSiteV1SearchRegionsCitiesResponse =
        await fetchCianApiMobileSiteV1SearchRegionsCities({
          httpApi,
          parameters: {
            text: '',
          },
          config: {
            subdomain,
            requestConfig: {
              withCredentials: false,
            },
          },
        });

      if (locationsData.statusCode !== 200) {
        dispatch(setStatusFailed());

        const error = new ResponseError({
          domain: 'geoLocation#getLocations',
          message: locationsData.response.data.message ?? 'Unknown error',
          details: {
            error: locationsData.response.data.errors as TPrimitives | TPrimitives[],
          },
        });

        logger.error(error);

        throw error;
      }

      const {
        response: {
          data: { items },
        },
      } = locationsData;
      if (!items) {
        dispatch(setStatusFailed());

        const error = new ResponseError({
          domain: 'geoLocation#getLocations',
          message: 'Unexpectedly empty locations list',
        });

        logger.error(error);

        throw error;
      }

      const locations: ILocation[] = prepareLocations(items);

      dispatch(setStatusSucceed(locations));

      return locations;
    } catch (ex) {
      dispatch(setStatusFailed());

      const error = new ResponseError({
        domain: 'geoLocation#getLocations',
        message: ex.message,
      });

      logger.error(error);

      throw error;
    }
  };
}
